
import { onMounted, ref } from "vue";

// import Site from "../Sites/Site.ts";
// import Job from "../Sites/Job.ts";
// import JobStatuses from "../Companies/JobStatuses"
//import { numberLiteralTypeAnnotation } from "@babel/types";

// import { Job } from "../Sites/Job";
import { IJob } from "../Sites/IJob";
import { Site } from "../Sites/Site";
import { VueElement } from "vue";
import { Job } from "@/Sites/Job";
import { IOfficerScheduleViewModel } from "@/OfficerSchedule/IOfficerScheduleViewModel";
import { OfficerScheduleViewModel } from "@/OfficerSchedule/OfficerScheduleViewModel";
import { computed } from "@vue/reactivity";

import { IScheduleViewModel } from "@/OfficerSchedule/IScheduleViewModel";
import { ScheduleViewModel } from "@/OfficerSchedule/ScheduleViewModel";
import { ByDateRangePageWisePostback } from "@/OfficerSchedule/ByDateRangePageWisePostback";
// import H from 'Here';

// import ICompany from "../Company/ICompany";
//import { ISite } from "../Sites/ISite";
export default {
  name: "ScheduleView",
  props: ["baseUrl"],
  setup(props: any) {
    //console.log("ALLAH Help me");
    const loggedIn = ref(false);
    const Jobs = ref<IOfficerScheduleViewModel[]>([]);
    const SelectedStartDate = ref(new Date());
    const SelectedEndDate = ref(new Date());

    const currentPageNo = ref(0);
    const startPageNumber = ref(1);
    const endPageNumber = ref(0);
    const LabelsPerPage = ref(5);
    const totalResultPages = ref(0);
    const totalRecordCount = ref(0);
    const recordsPerPage = ref(31);
    const isRangeGreater_Than_LabelsPerPage = ref(false);
    const isRangeLess_Than_TotalResultPages = ref(false);
    const location = ref(null);
    const gettingLocation = ref(false);
    const errorStr = ref(null);

    /******************/
    {
      //console.log("getScheduleForToday : ");
      var token = localStorage.getItem("Guardtoken");
      //console.log("token :  : ", token);

      if (token == null) loggedIn.value = false;
      else loggedIn.value = true;
    }


    const selectedPageClass =  function(pageNo:number){
      let classObject = {'bg-danger':false, 'bg-success':true};
      let differenceOfPageNumbers = currentPageNo.value - (pageNo - 1);
      //console.log("differenceOfPageNumbers :", differenceOfPageNumbers);
      switch(differenceOfPageNumbers)
      {

        case 0:
          classObject['bg-danger'] = true;
          classObject['bg-success'] = false;
          break;
        default:
          classObject['bg-danger'] = false;
          classObject['bg-success'] = true;
          break;
      }

      //console.log("classObject :", classObject);
      return classObject;

    }

    const getLocation = () => {
      return new Promise((resolve, reject) => {
        if (!("geolocation" in navigator)) {
          reject(new Error("Geolocation is not available."));
        }
        navigator.geolocation.getCurrentPosition(
          (pos) => {
            // console.log("pos.coords.longitude", pos.coords.longitude);
            // console.log("pos.coords.latitude", pos.coords.latitude);

            let requestUrl =
              "https://api.mapbox.com/geocoding/v5/mapbox.places/" +
              pos.coords.longitude +
              "," +
              pos.coords.latitude +
              ".json?access_token=pk.eyJ1Ijoic2hvdWtldGFsaSIsImEiOiJja3Vicmxqb3UwYzlnMnFvNmNhMDJ5dmJiIn0.bsT85MRV63Qr_kyl2RpJbQ";

            let requestOptions = {
              method: "GET",
              headers: {
                "content-type": "application/json",
              },
            };
            fetch(requestUrl, requestOptions).then((response) => {
              //console.log("response", response.json());
            });
            resolve(pos);
          },
          (err) => {
            reject(err);
          }
        );
      });
    };

    // const getLocation = () => {
    //   var platform = new H.service.Platform({
    //     apikey: "niOfEwVAwYq4qwRQLc4GrNytN177KFqbz2qe3xYHi7Y",
    //   });

    //   const geocoder = platform.getGeocodingService();

    //   return new Promise((resolve, reject) => {
    //     if (!("geolocation" in navigator)) {
    //       reject(new Error("Geolocation is not available."));
    //     }

    //     navigator.geolocation.getCurrentPosition(
    //       (pos) => {
    //         let reverseGeocodingParameters = {
    //           prox: `${pos.coords.latitude},${pos.coords.longitude}`,
    //           mode: "retrieveAddresses",
    //           maxresults: 1,
    //         };

    //         geocoder.reverseGeocode(
    //           reverseGeocodingParameters,
    //           (res: { Response: { View: any } }) => {
    //             let results = res.Response.View;
    //             if (results.length === 0) {
    //               resolve("No match.");
    //             } else {
    //               resolve(results[0].Result[0].Location);
    //             }
    //           },
    //           (e: any) => reject(e)
    //         );
    //       },
    //       (err) => {
    //         reject(err);
    //       }
    //     );
    //   });
    // };

    const locateMe = () => {
      gettingLocation.value = true;

      gettingLocation.value = false;
      getLocation()
        .then((res) => {
          //alert("res : " + res);
          //console.log("res", res);
        })
        .catch((e) => {
          gettingLocation.value = false;
          errorStr.value = e.message;
        });
    };

    const AcceptJob = (jobId: number) => {
      //let requestUrl = "https://localhost:44325/" + "Schedule/UpdateJobStatusNew";//http://emergingsols.somee.com/
      //let requestUrl = "http://emergingsols2.somee.com/" + "Schedule/UpdateJobStatusNew";//http://emergingsols.somee.com/

      var requestUrl = baseUrlAddress.value + "Schedule/UpdateJobStatusNew";

      //console.log("requestUrl : ", requestUrl);

      let requestOptions = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${localStorage.Guardtoken}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          Id: jobId, //localStorage.getItem("officerId"), //1501,
          JobStatusId: 7,
        }),
      };

      fetch(requestUrl, requestOptions)
        .then((response) => response.json())
        .then((res) => {
          let statusId = res.responseResult.jobStatus;

          if (statusId == "7") {
            alert("status updated successfully");
            //console.log("currentPageNo.value :", currentPageNo.value);
            GetOfficerSchedule(currentPageNo.value );
          }
          else{
            alert("job status could not be updated. Please re-try.");
          }

          res.scheduleSinglePageResult.forEach(
            (j: IOfficerScheduleViewModel) => {
              Jobs.value.push(
                new OfficerScheduleViewModel(j.jobDate, j.scheduleViewModel)
              );
              diplayResultPageList();
            }
          );
        });

       
    };

    const isJobAcceptanceRequired = (jobStatus: number) => {
      if (jobStatus == 1 || jobStatus == 3) return true;
      return false;
    };
    const isShownPageButton = (pageNo: number) => {
      return (
        pageNo > startPageNumber.value &&
        pageNo <= startPageNumber.value + LabelsPerPage.value
      );
      
    };

    const diplayResultPageList = () => {
      totalResultPages.value = Math.ceil(
        totalRecordCount.value / recordsPerPage.value
      );
      let sectionNo = Math.floor(currentPageNo.value / LabelsPerPage.value);
      startPageNumber.value = sectionNo * LabelsPerPage.value;
      endPageNumber.value = (sectionNo + 1) * LabelsPerPage.value;

      if (endPageNumber.value >= totalResultPages.value) {
        //we don't need a previous-result-pages-arrow
        isRangeGreater_Than_LabelsPerPage.value = false;
        endPageNumber.value = totalResultPages.value;
      } else {
        //we need a previous-result-pages-arrow
        isRangeGreater_Than_LabelsPerPage.value = true;
      }

      if (startPageNumber.value >= LabelsPerPage.value) {
        isRangeLess_Than_TotalResultPages.value = true;
      } else {
        isRangeLess_Than_TotalResultPages.value = false;
      }
    };

    const GetOfficerSchedule = (pageNo: number) => {
      totalRecordCount.value = 0;
      endPageNumber.value = 0;
      Jobs.value = Jobs.value.splice(0, 0);
      let Guardtoken = localStorage.getItem("Guardtoken")!;
      let OfficerId = localStorage.getItem("OfficerId")!;

      currentPageNo.value = pageNo;
      //console.log("Guardtoken : ", Guardtoken);
      //console.log("OfficerId : ", OfficerId);
      // console.log("fetchPageNo : ", fetchPageNo);

      let requestUrl = baseUrlAddress.value +
        "Schedule/ScheduleForSecurityOfficerWithoutTimespan";//http://emergingsols.somee.com/


      // let requestUrl =
      //   "https://localhost:44325/" +
      //   "Schedule/ScheduleForSecurityOfficerWithoutTimespan";//http://emergingsols.somee.com/

      // let requestUrl =
      //   "http://emergingsols2.somee.com/" +
      //   "Schedule/ScheduleForSecurityOfficerWithoutTimespan";//http://emergingsols.somee.com/
      let requestOptions = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${Guardtoken}`, //`Bearer ${localStorage.Guardtoken}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          securityOfficerId: parseInt(OfficerId), //localStorage.getItem("officerId"), //1501,
          startDate: SelectedStartDate.value, // new Date("2021-10-12T04:24:15.995Z"),
          endDate: SelectedEndDate.value, // new Date("2022-10-12T04:24:15.995Z"),
          pageNumber: pageNo, //0, //fetchPageNo, // 0,
          recordsPerPage: recordsPerPage.value,
          entitiesPerPage: 2, //not used by the web-api during query-processing
        }),
      };

      fetch(requestUrl, requestOptions)
        .then((response) => response.json())
        .then((res) => {
          //console.log("res", res);
          totalRecordCount.value = res.totalJobsForOfficer;
          res.scheduleSinglePageResult.forEach(
            (j: IOfficerScheduleViewModel) => {
              Jobs.value.push(
                new OfficerScheduleViewModel(j.jobDate, j.scheduleViewModel)
              );
              diplayResultPageList();
            }
          );
        });

      onMounted(() => {
        //"getScheduleForToday : ");
        if (localStorage.getItem("Guardtoken") == null) loggedIn.value = false;
        else loggedIn.value = true;
      });
    };

    const baseUrlAddress = computed(() => {
      return `${props.baseUrl}`;
    });

    GetOfficerSchedule(0);

    // onMounted (() =>{
    //   GetOfficerSchedule(0);
    // })

    return {
      Jobs,
      loggedIn,
      GetOfficerSchedule,
      diplayResultPageList,
      baseUrlAddress,
      isShownPageButton,
      AcceptJob,
      isJobAcceptanceRequired,
      SelectedStartDate,
      getLocation,
      locateMe,
      errorStr,
      location,
      gettingLocation,
      SelectedEndDate,
      currentPageNo,
      selectedPageClass,
      startPageNumber,
      endPageNumber,
      LabelsPerPage,
      totalResultPages,
      totalRecordCount,
      recordsPerPage,
      isRangeGreater_Than_LabelsPerPage,
      isRangeLess_Than_TotalResultPages,
    };
  },
  methods: {
    dateToYYYYMMDD(d: Date) {
      // alternative implementations in https://stackoverflow.com/q/23593052/1850609
      return (
        new Date(d)
          // .toLocaleString("en-GB", { timeZone: "UTC" })
          .toLocaleString()
          .substring(0, 10)
      );
    },
  },

  created() {
    //console.log("ALLAH Help me");
  },
};
